import { config } from '../../environment-config';
export default config;
